var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 15,
    viewBox: "0 0 227 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_1538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227 3H194V14H227V3Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 1H192V12H215V1Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 0H190V10H213V0Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 0H0V8H227V0Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 3H0V14H30V3Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 1H2V12H32V1Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 0H4V10H34V0Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 13.98H0V15H31V13.98Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 12H30V15H31V12Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 12H30V13H33V12Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 10H32V13H33V10Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 10H32V11H35V10Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 8H34V10H35V8Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 8H34V9H190V8Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 8H189V11H190V8Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 10H190V11H192V10Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 10H191V13H192V10Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 12H191V13H194V12Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 13H193V15H194V13Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 14H193V15H227V14Z",
    fill: "#142E4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_1538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 227,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBar);
export default __webpack_public_path__ + "static/media/top-bar.6666b66cdcf71fa15261e06f8f9fee58.svg";
export { ForwardRef as ReactComponent };